module.exports = __webpack_public_path__ + "img/car_transm.df0b34e6.svg";